// extracted by mini-css-extract-plugin
export default {"app":"App_app__VPPHV","menu_visible":"App_menu_visible__YjRlO"};